/*import axios from "axios";
import {getServerURL} from './config';

const clienteAxios = axios.create({baseURL: getServerURL()});

export default clienteAxios;*/

import axios from "axios";
import { getServerURL } from "./config";

//Naquina Desarrollo
const clienteAxios = axios.create({
    baseURL: getServerURL(),
    headers: {
        'Content-Type': 'application/json'
    }
});
//Para que otro pueda acceder es http://192.0.99.131:19006

clienteAxios.interceptors.response.use(
    response => response,
    error => {
        const msg = error.response?.data?.msg;
        if (error.response?.status === 401 &&
            (msg === 'password changed' || msg === 'user disabled' || msg === 'jwt expired')) {
            localStorage.removeItem('token');
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);

export default clienteAxios;